import api from "@/lib/api";

export type MenuKey = "latest" | "sectors" | "markets" | "premium" | "more";

export const PANEL_WIDTHS: Record<MenuKey, number> = {
  latest: 1400,
  sectors: 1400,
  markets: 1400,
  premium: 1400,
  more: 1080,
};

export type NavItem = { key: string; name: string; path: string | null; panel: MenuKey | null };

export const NAV_ITEMS: NavItem[] = [
  { key: "latest", name: "Latest", path: "/latest", panel: "latest" },
  { key: "briefs", name: "Daily Brief", path: "/briefs", panel: null },
  { key: "sectors", name: "Sectors", path: null, panel: "sectors" },
  { key: "markets", name: "Markets", path: "/markets", panel: "markets" },
  { key: "premium", name: "Premium", path: null, panel: "premium" },
  { key: "more", name: "More", path: null, panel: "more" },
];

export type Sector = { slug: string; to: string; label: string; desc: string };

export const SECTORS: Sector[] = [
  { slug: "crypto", to: "/crypto", label: "Crypto", desc: "Bitcoin, Ethereum, altcoins and ETFs" },
  { slug: "defi", to: "/defi", label: "DeFi", desc: "Protocols, stablecoins, yield and security" },
  { slug: "web3", to: "/web3", label: "Web3", desc: "NFTs, gaming, DAOs and digital identity" },
  { slug: "blockchain", to: "/blockchain", label: "Blockchain", desc: "Layer 1s, Layer 2s and infrastructure" },
  { slug: "ai", to: "/ai", label: "Artificial Intelligence", desc: "Models, agents and the AI-crypto frontier" },
  { slug: "quantum", to: "/quantum", label: "Quantum", desc: "Quantum computing and post-quantum security" },
  { slug: "government-policy", to: "/policy", label: "Policy", desc: "Regulation, enforcement and lawmakers" },
  { slug: "research", to: "/research", label: "Research", desc: "Deep dives from the NewsLayer desk" },
  { slug: "explainers", to: "/explainers", label: "Explainers", desc: "Plain-English guides to complex topics" },
];

export const SECTOR_LABELS: Record<string, string> = Object.fromEntries(
  SECTORS.map((s) => [s.slug, s.label]),
);

export const COIN_META: Record<string, { name: string; color: string; glyph: string }> = {
  BTC: { name: "Bitcoin", color: "#F7931A", glyph: "₿" },
  ETH: { name: "Ethereum", color: "#627EEA", glyph: "Ξ" },
  SOL: { name: "Solana", color: "#9945FF", glyph: "◎" },
  XRP: { name: "XRP", color: "#8A94A6", glyph: "✕" },
  DOGE: { name: "Dogecoin", color: "#C2A633", glyph: "Ð" },
  ADA: { name: "Cardano", color: "#2E5BFF", glyph: "₳" },
};

export const MORE_GROUPS: { label: string; links: { label: string; to: string; external?: boolean }[] }[] = [
  {
    label: "Discover NewsLayer",
    links: [
      { label: "About NewsLayer", to: "/about" },
      { label: "Entities", to: "/entities" },
      { label: "Contact", to: "mailto:newslayerapp@gmail.com", external: true },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Terms of Service", to: "/terms" },
    ],
  },
  {
    label: "Build With Us",
    links: [
      { label: "Become an Author", to: "/author-program" },
      { label: "Author Studio", to: "/studio" },
    ],
  },
  {
    label: "For Business",
    links: [
      { label: "Advertise", to: "/advertise" },
      { label: "PR Publication", to: "/pr" },
    ],
  },
  {
    label: "Connect",
    links: [
      { label: "X (Twitter)", to: "https://x.com/newslayerapp", external: true },
      { label: "Telegram", to: "https://t.me/newslayerapp", external: true },
      { label: "Podcast", to: "/briefs" },
    ],
  },
];

export const track = (event_type: string, metadata: Record<string, unknown> = {}) => {
  api.post("/analytics/track", { event_type, metadata }).catch(() => {});
};
